<template>
<div>     

<div class="d-none d-md-block"  > 


  <b-navbar toggleable="md" type="light" variant="light" fixed="top" >
  
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav  class="mx-auto " style="width: 865px;">
    <b-nav-item to="/"><b-img src="@/assets/logo.svg" width="190"  > </b-img></b-nav-item>
    <b-nav-item class="p-4 align-self-center" to="/anounces"><h3>{{ $t('message.anounces', { anounces: 'Anounces' }) }}</h3></b-nav-item>
    <b-nav-item class="p-4 align-self-center" to="/members"><h3>{{ $t('message.members', { members: 'Members' }) }}</h3></b-nav-item>
    <b-nav-item class="p-4 align-self-center" to="/videos"><h3>{{ $t('message.videos', { videos: 'Video' }) }}</h3></b-nav-item>
    <b-nav-item class="p-4 align-self-center" to="/contacts"><h3>{{ $t('message.contacts', { contacts: 'Contacts' }) }}</h3></b-nav-item>
    
    <!--  b-nav-item><SwitchLanguage /></b-nav-item-->
    
    <b-nav-item><locale-switcher :locales="['en', 'ua']" :show-full="true" ></locale-switcher></b-nav-item>
    
    
      </b-navbar-nav>
     </b-collapse>


  </b-navbar>

  
  <div  >
  <br><br>
</div>
</div>

     <div class="d-block d-md-none" >
         <b-navbar toggleable="md" type="light" variant="light" fixed="top" >
            <b-navbar-nav  class="mx-auto " >
              <b-nav-item to="/"><b-img src="@/assets/logo.svg" width="120"  > </b-img></b-nav-item>
              <!--  b-nav-item><SwitchLanguage /></b-nav-item -->
              <b-nav-item><locale-switcher :locales="['en', 'ua']" :show-full="true" ></locale-switcher></b-nav-item>
              
              

            </b-navbar-nav>
            <Sidebar msg="Menu" />
         </b-navbar>
      </div>      

<div>
  <br><br><br><br><br><br><br>
</div>

     <!-- div class="d-block d-md-none" >
        <b-row>
          <b-col class="col-2 col-xl-5"></b-col>
          <b-col class="col-7 col-xl-6">
            <div>
            <b-link href=/>
               <b-img src="@/assets/logo.svg" width="190"  class="img-responsive"> </b-img>
            </b-link>
            </div>
          </b-col>
          <b-col class="col-3 col-xl-1">                
              <Sidebar msg="Menu" />
          </b-col>
        </b-row>
      </div -->      



</div>

</template>

<script>

import Sidebar from '@/components/Sidebar.vue'
// import SwitchLanguage from '/src/components/SwitchLanguage.vue'
import LocaleSwitcher from '/src/components/Locale-Switcher.vue'



export default {
  name: 'AppHeader',
  props: {
    msg: String
  },
  components: {
    Sidebar,
    // SwitchLanguage,
    LocaleSwitcher,
 

  }

}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap');
 h1, h2, h3, h4, h5, h6 { font-family: 'Fira Sans', sans-serif; }



h3.textcenter {
   text-align: center  
}

h2.textcenter {
   text-align: center  
}

h1.textcenter {
   text-align: center  
}

</style>